<button mat-button type='button' (click)="scan()">
    <mat-icon svgIcon='barcode-scanner'></mat-icon>
</button>
